export const ImpersonateAsLocalStorageKey = 'impersonate-as';

interface ImpersonationOptions {
  reload?: boolean;
}

export const impersonateAs = (impersonatedUserId: string, { reload = true }: ImpersonationOptions = {}) => {
  window.localStorage.setItem(ImpersonateAsLocalStorageKey, impersonatedUserId);
  if (reload) {
    window.location.href = '/';
  }
};

export const clearImpersonation = ({ reload = true }: ImpersonationOptions = {}) => {
  window.localStorage.removeItem(ImpersonateAsLocalStorageKey);
  if (reload) {
    window.location.href = '/';
  }
};

export const getLocalStorageImpersonatedAsUserId = (): string | null =>
  window.localStorage.getItem(ImpersonateAsLocalStorageKey);
